<!-- 巡检工单统计 -->
<template>
  <div class="inspection-workorder-stats">
    <!-- 头部信息区域 -->
    <div class="header-section">
      <div class="header-title">
        <h2>工单统计</h2>
        <div class="data-update-time">
          数据更新时间: {{ dataUpdateTime }}
        </div>
      </div>

      <!-- 筛选条件 -->
      <div class="filter-section">
        <div class="filter-item">
          <span class="filter-label">时间范围:</span>
          <el-select v-model="timeRange" @change="handleTimeRangeChange" style="width: 120px;">
            <el-option label="近7天" value="7"></el-option>
            <el-option label="近30天" value="30"></el-option>
          </el-select>
        </div>

        <div class="filter-buttons">
          <el-button
            :type="workorderType === 'all' ? 'primary' : ''"
            @click="handleWorkorderTypeChange('all')"
          >
            全部工单
          </el-button>
          <el-button
            :type="workorderType === 'repair' ? 'primary' : ''"
            @click="handleWorkorderTypeChange('repair')"
          >
            维修工单
          </el-button>
          <el-button
            :type="workorderType === 'inspection' ? 'primary' : ''"
            @click="handleWorkorderTypeChange('inspection')"
          >
            巡检工单
          </el-button>
          <el-button type="primary" @click="handleQuery">
            查询
          </el-button>
        </div>
      </div>
    </div>

    <!-- 统计卡片区域 -->
    <stats-cards :stats-data="statsData" :loading="loading"></stats-cards>

    <!-- 图表区域 -->
    <charts-section
      :daily-count-data="dailyCountData"
      :status-stats-data="statusStatsData"
      :daily-avg-hours-data="dailyAvgHoursData"
      :summary-data="summaryData"
      :loading="chartsLoading"
    ></charts-section>
  </div>
</template>

<script>
import StatsCards from './components/StatsCards.vue';
import ChartsSection from './components/ChartsSection.vue';
import {
  getWorkorderStats,
  getDailyCountWeek,
  getStatusStatsWeek,
  getDailyAvgHoursWeek,
  getWorkorderSummary
} from './api';
import {formatDateTime} from "@/util/date";

export default {
  name: 'InspectionWorkorderStats',
  components: {
    StatsCards,
    ChartsSection
  },
  data() {
    return {
      loading: false,
      chartsLoading: false,
      timeRange: '7',
      workorderType: 'all',
      dataUpdateTime: '',
      statsData: {},
      dailyCountData: [],
      statusStatsData: {},
      dailyAvgHoursData: [],
      summaryData: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    async init() {
      this.dataUpdateTime = formatDateTime(new Date());
      await this.loadStatsData();
      await this.loadChartsData();
    },

    // 加载统计数据
    async loadStatsData() {
      this.loading = true;
      try {
        const response = await getWorkorderStats(parseInt(this.timeRange));
        if (response.data) {
          this.statsData = response.data.data;
        }
      } catch (error) {
        console.error('加载统计数据失败:', error);
        this.$message.error('加载统计数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 加载图表数据
    async loadChartsData() {
      this.chartsLoading = true;
      try {
        const days = parseInt(this.timeRange);
        const [summaryResponse, countResponse, statusResponse, avgHoursResponse] = await Promise.all([
          getWorkorderSummary(days),
          getDailyCountWeek(),
          getStatusStatsWeek(),
          getDailyAvgHoursWeek()
        ]);

        if (summaryResponse.data) {
          this.summaryData = summaryResponse.data.data || {};
        } else {
          this.summaryData = {};
        }
        if (countResponse.data) {
          this.dailyCountData = countResponse.data.data;
        }
        if (statusResponse.data) {
          this.statusStatsData = statusResponse.data.data;
        }
        if (avgHoursResponse.data) {
          this.dailyAvgHoursData = avgHoursResponse.data.data;
        }
      } catch (error) {
        console.error('加载图表数据失败:', error);
        this.$message.error('加载图表数据失败');
      } finally {
        this.chartsLoading = false;
      }
    },

    // 时间范围变化
    handleTimeRangeChange(value) {
      this.timeRange = value;
      this.loadStatsData();
      this.loadChartsData();
    },

    // 工单类型变化
    handleWorkorderTypeChange(type) {
      this.workorderType = type;
    },

    // 查询
    handleQuery() {
      this.loadStatsData();
      this.loadChartsData();
    },
  }
};
</script>

<style lang="scss" scoped>
.inspection-workorder-stats {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;

  .header-section {
    background: white;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .header-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 600;
        color: #303133;
      }

      .data-update-time {
        font-size: 14px;
        color: #909399;
      }
    }

    .filter-section {
      display: flex;
      align-items: center;
      gap: 20px;

      .filter-item {
        display: flex;
        align-items: center;
        gap: 8px;

        .filter-label {
          font-size: 14px;
          color: #606266;
          white-space: nowrap;
        }
      }

      .filter-buttons {
        display: flex;
        gap: 10px;

        .el-button {
          padding: 8px 16px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
